import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import { IInstagramSourceAndCountWithAutocomplete } from '@instagram-account/models/IInstagramAutocompleteResponses';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { UniversalSearchSortKey } from '@models/UniversalSearchSortKey';

export interface IInstagramHashtagRecentContentState {
  autocompleteResults: IInstagramSourceAndCountWithAutocomplete[];
  errors: {
    fetchInstagramHashtagAutocompleteError?: string;
    fetchInstagramHashtagRecentContentError?: string;
    fetchInstagramRelatedHashtagsError?: string;
    fetchMoreInstagramHashtagRecentContentError?: string;
  };
  filterState: IInstagramHashtagContentFilter;
  flags: {
    isEndOfInstagramHashtagRecentContentReached: boolean;
    isFetchingInstagramHashtagAutocomplete: boolean;
    isFetchingInstagramHashtagRecentContent: boolean;
    isFetchingInstagramRelatedHashtags: boolean;
    isFetchingMoreInstagramHashtagRecentContent: boolean;
  };
  items: IMlsMediaItem[];
  offset: number;
  relatedHashtags: IInstagramSourceAndCountWithAutocomplete[];
  totalMediaCount: number;
}

export interface IInstagramHashtagContentFilter {
  sort: UniversalSearchSortKey;
  searchTerms: IInstagramSourceAndCountWithAutocomplete[];
}

export const RECENT_CONTENT_REQUEST_LIMIT = 50;
